import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface ViewsState {
  lastUpdated: number | null;
  module: string | null;
}

const initialState: ViewsState = {
  lastUpdated: null,
  module: null,
};

const viewsSlice = createSlice({
  name: "views",
  initialState,
  reducers: {
    notifyViewUpdated: (state, action: PayloadAction<{ module: string }>) => {
      state.lastUpdated = Date.now();
      state.module = action.payload.module;
    },
  },
});

export const { notifyViewUpdated } = viewsSlice.actions;
export default viewsSlice.reducer;
